import type { ResponsiveImageData } from '../../types/responsiveImage'
import type { CtaButton } from '../../utils/ctaUtils'
import * as React from 'react'
import { ResponsiveImage, Container, ButtonLink } from './'

export interface HeroProps {
  title: string
  lead?: string
  image?: ResponsiveImageData
  ctaPrimary?: CtaButton
  ctaSecondary?: CtaButton
  className?: string
  children?: React.ReactNode
}

export const Hero = ({
  title,
  lead,
  image,
  ctaPrimary,
  ctaSecondary,
  className = 'min-h-[max(700px,80svh)]',
  children,
}: HeroProps) => {
  return (
    <section data-hero className={`relative overflow-hidden ${className}`}>
      {image && (
        <div aria-hidden="true" className="absolute inset-0">
          <ResponsiveImage
            data={image}
            className="h-full w-full object-cover"
            fetchpriority="high"
          />
        </div>
      )}

      <div
        aria-hidden="true"
        className="hero__overlay absolute inset-0 mix-blend-multiply"
      />

      <Container
        className="relative flex min-h-[inherit] items-end pb-14 md:pb-20"
      >
        <div className="col-span-6 flex flex-col gap-6 md:col-span-8 md:gap-9">
          <h1 className="font-serif text-4xl leading-tightest text-white md:text-7xl">
            {title}
          </h1>

          {lead && (
            <p className="text-xl leading-snug text-white md:text-2xl">
              {lead}
            </p>
          )}

          {(ctaPrimary || ctaSecondary) && (
            <div className="flex gap-2 md:gap-3">
              {ctaPrimary && (
                <ButtonLink
                  href={ctaPrimary.url}
                  label={ctaPrimary.label}
                  variant="button-white"
                />
              )}
              {ctaSecondary && (
                <ButtonLink
                  href={ctaSecondary.url}
                  label={ctaSecondary.label}
                  variant="button"
                />
              )}
            </div>
          )}

          {children}
        </div>
      </Container>
    </section>
  )
}
